/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import jwt_decode from "jwt-decode";
import Navbar from "../../Navbar";
import Header from "../../Header";
import baseUrl from "../../BaseUrl";
import Loader from "../../Loader";
import { useNavigate, Link } from 'react-router-dom';
 
const Index = () => {
    const [name, setName] = useState('');
    const [token, setToken] = useState('');
    const [cid, setCid] = useState('');
    const [expire, setExpire] = useState('');
    // const [users, setUsers] = useState([]);
    // const [error, setError] = useState(null);
    const [role, setRole] = useState('');
    const [access, setAccess] = useState([]);
    const [digitMapping, setDigitMapping] = useState(false);
    const [userDigitMapping, setUserDigitMapping] = useState(false);
    const [reportAccess, setReportAccess] = useState(false);
    const [userReportAccess, setUserReportAccess] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false);
    const [inventoryAccess, setInventoryAccess] = useState(false);
    const [userInventoryAccess, setUserInventoryAccess] = useState(true);
    const [isNumberManagementPermission, setIsNumberManagementPermission] = useState(0);
    const [userManageTagAccess, setUserManageTagAccess] = useState(false);
    const navigate = useNavigate();
 
    useEffect(() => {
        refreshToken();
        getUserAccess(); 
        checkNumberManagementPermission();       
        // getUsers();
    }, []);

    useEffect(() => {
        if(cid){
            getCustomerDigitMappingAccess();
        }
    }, [cid]);
 
    const refreshToken = async () => {
        try {
            const response = await axios.get(`${baseUrl}/token`);
            
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            console.log(decoded);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        } catch (error) {
           
            if (error.response) {
                // setError("Unauthorized");
                navigate("/");  
                window.location.reload();
            }
        }
    }
    const getUserAccess = async () => {
        try {
            setPopupOpen(true);
            const response = await axiosJWT.get(`${baseUrl}/user-access`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            setPopupOpen(false);
            console.log(response.data.results);
            setAccess(response.data.results);
            setUserInventoryAccess(response.data.user_inventory_switch == 0 ? false : true);
            setUserDigitMapping(response.data.user_digit_mapping_switch == 0 ? false : true);
            setUserReportAccess(response.data.user_report_switch == 0 ? false : true);
            setUserManageTagAccess(response.data.user_manage_tags == 0 ? false : true);
            
            
        } catch (error) {
           console.log(error);
        //    setIsLoading(false);
            // if (error.response) {
            //     // setError("Unauthorized");
            //     navigate("/");  
            //     window.location.reload();
            // }
        }
    }

    
    const hasPermission = (permission) => {
        return access.some((item) => item.access === permission);
      };
 
    const axiosJWT = axios.create();
 
    axiosJWT.interceptors.request.use(async (config) => {
        const currentDate = new Date();
        if (expire * 1000 < currentDate.getTime()) {
            const response = await axios.get(`${baseUrl}/token`);
            config.headers.Authorization = `Bearer ${response.data.accessToken}`;
            setToken(response.data.accessToken);
            const decoded = jwt_decode(response.data.accessToken);
            setName(decoded.name);
            setRole(decoded.role)
            setExpire(decoded.exp);
            setCid(decoded.cid);
        }
        return config;
    }, (error) => {
        return Promise.reject(error);
    });
 
    const getCustomerDigitMappingAccess = async () => {
        try {
            // setApiCallCount((prevCount) => prevCount + 1);
            const response = await axios.get(`${baseUrl}/check-company-e911-access/${cid}`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }       
            });
            console.log(response.data);
            setDigitMapping(response.data.digit_mapping_switch === 1 ? true : false);
            setReportAccess(response.data.report_switch === 1 ? true : false);
            setInventoryAccess(response.data.inventory_switch === 1 ? true : false);

        } catch (error) {
            // setLoading(false);
            
           console.log(error);
            
        }
    };

    const checkNumberManagementPermission= async () => {
        const response = await axiosJWT.get(`${baseUrl}/check-number-management-permission`,{
            headers: {
                Authorization: `Bearer ${token}`
            }
        });
        setIsNumberManagementPermission(response.data.NumberManagementAccess);
        if(response.data.NumberManagementAccess == 0){
            navigate('/dashboard');
        }
    }
 
    return (
        <div className="panelbox">
           <Navbar  token={token} access = {access}/>
            <div className="right-panel">
            <Header name={name} />
            {popupOpen && (
                     <Loader /> 
                ) }
                <div className="content-page">
                    <div className="row">
                        <div className="col-6">
                            <div className="left-title">
                                <h1>Imports</h1>
                            </div>
                        </div>
                        <div className="col-6">

                        </div>
                    </div>
                    <div className="row numberboxes">
                        
                        {(role <=2 && hasPermission('ordernewnumber')  && isNumberManagementPermission==1) && <div className="col-md-3">
                        <Link to={"/import-did-inventory"}>
                            <div className="dashboard-box" id="importdid">
                                <div className="imagebox">
                                    <img src="images/bxs-file-import.png" />
                                </div>
                                <h3>Import DID inventory</h3>
                                {/* <p>Order and modify phone numbers and features.</p> */}
                            </div>
                            </Link>
                        </div>}                       
                        {(role <=2 && hasPermission('ordernewnumber') && isNumberManagementPermission==1) && <div className="col-md-3">
                        <Link to={"/import-note-into-inventory"}>
                            <div className="dashboard-box" id="orderbox">
                                <div className="imagebox">
                                    <img src="images/bxs-features.png" />
                                </div>
                                <h3>Import note to number</h3>
                                {/* <p>Order and modify phone numbers and features.</p> */}
                            </div>
                            </Link>
                        </div>}  
                        {(role <=2 && isNumberManagementPermission==1) && <div className="col-md-3">
                            <Link to="/import-non-supported-carrier-cnam">
                            <div className="dashboard-box" id="userbox">
                                <div className="imagebox">
                                    <img src="images/bxs-edit.png" />
                                </div>
                                <h3>Non-Supported Carrier CNAM</h3>
                            </div>
                            </Link>
                        </div>}
                        {(role <=2 && isNumberManagementPermission==1) && <div className="col-md-3">
                            <Link to="/import-supported-carrier-cnam">
                            <div className="dashboard-box" id="viewtrans">
                                <div className="imagebox">
                                    <img src="images/bxs-edit.png" />
                                </div>
                                <h3>Supported Carrier CNAM</h3>
                            </div>
                            </Link>
                        </div>}
                        {(role <=2 && isNumberManagementPermission==1) && 
                        <div className="col-md-3">
                            <Link to={"/import-portal-number-remove"}>
                            <div className="dashboard-box" id="orderbox">
                                <div className="imagebox">
                                    <img src="images/bxs-cart.png" />
                                </div>
                                <h3>Remove Numbers</h3>
                            </div>
                            </Link>
                        </div>}
                        {(role <=2 && hasPermission('ordernewnumber') && isNumberManagementPermission==1) && <div className="col-md-3">
                            <Link to="/bulk-number-change-route">
                            <div className="dashboard-box" id="viewtrans">
                                <div className="imagebox">
                                    <img src="images/bxs-edit.png" />
                                </div>
                                <h3>Bulk Number Change Route</h3>
                            </div>
                            </Link>
                        </div>}
                        {hasPermission('callpassaccess') && <div className="col-md-3">
                        <Link to={"/call-pass-settings"}>
                            <div className="dashboard-box" id="importdid">
                                <div className="imagebox">
                                    <img src="images/bxs-file-import.png" />
                                </div>
                                <h3>Call Pass Settings</h3>
                                {/* <p>Order and modify phone numbers and features.</p> */}
                            </div>
                            </Link>
                        </div>}
                        {role <= 2 && <div className="col-md-3">
                            <Link to="/cia-number-setting">
                            <div className="dashboard-box" id="featurebox">
                                <div className="imagebox">
                                    <img src="images/bxs-features.png" />
                                </div>
                                <h3>E-NRMS Enable</h3>
                                {/* <p>Order and modify phone numbers and features.</p> */}
                            </div>
                            </Link>
                        </div>}
                        {role <= 2 && <div className="col-md-3">
                            <Link to="/import-do-not-originate">
                            <div className="dashboard-box" id="bbdbox">
                                <div className="imagebox">
                                    <img src="images/bxs-phone-off.png" />
                                </div>
                                <h3>Do Not Originate (DNO)</h3>
                            </div>
                            </Link>
                        </div>}
                        {role <= 2  && <div className="col-md-3">
                        <Link to={"/import-no-number-reputation"}>
                            <div className="dashboard-box" id="inventory">
                                <div className="imagebox">
                                    <img src="images/bxs-paste.png" />
                                </div>
                                <h3>No Number Reputation</h3>
                            </div>
                            </Link>
                        </div>}  
                        {(role <=2) && 
                        <div className="col-md-3">
                            <Link to={"/import-dmt-sync"}>
                            <div className="dashboard-box" id="orderbox">
                                <div className="imagebox">
                                    <img src="images/bxs-cart.png" />
                                </div>
                                <h3>DMT Sync</h3>
                            </div>
                            </Link>
                        </div>}
                        {(role <=2 || userManageTagAccess) && <div className="col-md-3">
                        <Link to={"/import-inventory-tags"}>
                            <div className="dashboard-box" id="importdid">
                                <div className="imagebox">
                                    <img src="images/bxs-file-import.png" />
                                </div>
                                <h3>Import Inventory Tags</h3>
                                {/* <p>Order and modify phone numbers and features.</p> */}
                            </div>
                            </Link>
                        </div>}   

                        {(role <= 2) && <div className="col-md-3">
                            <Link to={"/import-call-pass-dirid-tn"}>
                                <div className="dashboard-box" id="importdid">
                                    <div className="imagebox">
                                        <img src="images/bxs-file-import.png" />
                                    </div>
                                    <h3>Import Call Pass Display Identity</h3>
                                </div>
                            </Link>
                        </div>}
                    </div>
                </div>
            </div>            
        </div>
    )
}
 
export default Index
